import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row, Input } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { DABInlineLoading, DABTextBoxWithSearch, DABTextBox } from '../../components/dab';
import { userAction } from '../../actions/userAction';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { showAlert } from "../common/functions";


interface IUserAddressProps {
	dispatch: Dispatch<any>;
	userData: any;
	userId: any;
	showSearch: any;
	title: any;
	isActive: any;
}

const UserAddress: React.SFC<IUserAddressProps> = ({
	dispatch, userData, userId, showSearch, isActive }) => {

	const initialInputValue = {
		sortDirection: 'desc',
		sortColumn:'',
		pageNumber: 1,
		pageSize: 5,
		searchString: "",
		userId: userId
	};

	const userAddressInput = {
		userId: 0,
		firstName: "",
		lastName: "",
		companyName: "",
		address1: "",
		address2: "",
		address3: "",
		city: "",
		region: "",
		postalCode: "",
		country: "",
		note:"",
		isPrimaryAddress: false,
		isShippingAddress: false
	}

	const shopifyAddressInput = {
		customerEmail: userData?.item?.email,
		searchString : ""
	}

	const [showModal, setShowModal] = useState(false);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [addressList, setAddressList] = useState([]);
	const [shopifyAddressList, setShopifyAddressList] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [searchShopifyText, setShopifySearchText] = useState("");
	const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
	const [userAddressInputs, setUserAddressInputs] = useState(userAddressInput);
	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [formSubmit, setformSubmit] = useState(false);
	const [userShopifyInputs, setUserShopifyInputs] = useState(shopifyAddressInput);

	React.useEffect(() => {
		dispatch(userAction.userGetAddress(filterInput));
		dispatch(userAction.userShopifyGetAddress(userShopifyInputs))
		setShowModal(true);
	}, [filterInput, userShopifyInputs]);

	const handleShopifyAddressFilter = () => {
		setUserShopifyInputs({
			...userShopifyInputs,
			searchString: searchShopifyText
		});
		setShowModal(true);
	};

	const handleFilter = () => {
		setFilterInput({
			...filterInput,
			pageNumber: 1,
			pageSize: 5,
			searchString: searchText
		});
		setShowModal(true);
	};


	if (userData) {
		if (userData.isUserAddressLoaded) {
			userData.isUserAddressLoaded = false;
			setShowModal(false);
			setAddressList(userData.userAddressData);
		}

		if (userData.isUserShopifyAddressLoaded) {
			userData.isUserShopifyAddressLoaded = false;
			setShowModal(false);
			setShopifyAddressList(userData.userShopifyAddressData);
		}

		if (userData.isSuccess && userData.isUserAddAddressLoaded && isAddDialogOpen && !userData.isError) {
			userData.isUserAddAddressLoaded = false;
			userData.isSuccess = false;
			showAlert(userData.status, false);
			setIsAddDialogOpen(false);
			handleFilter();
			setUserAddressInputs(userAddressInput);
		}

		if (!userData.isSuccess	&& userData.isError) {
			if (userData.isUserAddAddressLoaded) {
				userData.isUserAddAddressLoaded = false;
				showAlert(userData.status, true);
			}
			userData.isError = false;			
			setShowModal(false);
		}
	}

	const handleInputChange = (event) => {
		setSearchText(event.target.value);
	};
	const handleShopifyInputChange = (event) => {
		setShopifySearchText(event.target.value);
	};
	const handleAddInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (value === "on") {
			value = event.target.checked
		}
		setUserAddressInputs({
			...userAddressInputs,
			firstName: userData.item.firstName,
			lastName: userData.item.lastName,
			[name]: value,
		});
		setIsDirty(true)
	};

	const handleAddOnClick = () => {
		setUserAddressInputs(userAddressInput);
		setIsAddDialogOpen(true);
	}

	const handleCloseClick = () => {
		setIsAddDialogOpen(false);
	}

	const handleAddSubmit = (event) => {
		if (isAddDialogOpen) {
			setformSubmit(true);
			event.preventDefault();
			userAddressInputs.userId = userId;
			dispatch(userAction.userSaveAddress({ userAddress: userAddressInputs }));
		}
	};

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	return (
		<div className="add-address">
			<Row className="ad-row">
				<Col className="verCenter" lg="3">
					<h5>
						<span data-testid="addressText">Addresses</span>
					</h5>
				</Col>
				{showSearch && <>
					<Col lg="3" data-testid="addButtonContainer">
						<Button id="submit" style={{ float: "right" }} color="primary" onClick={() => { handleAddOnClick() }} disabled={!isActive}>Add</Button>
					</Col>
					<Col lg="6" style={{ float: "right" }}>
						<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
							onChange={(event) => { handleInputChange(event) }}
							value={searchText} onClick={(event) => { handleFilter() }}
						/>
					</Col>
				</>
				}
			</Row>

			<table className="table table-bordered text-center" data-testid="addressTable">
				<thead>
					<tr>
						<th data-testid="address" key="address" scope="col">Address</th>
						<th data-testid="city" key="city" scope="col">City</th>
						<th data-testid="state" key="state" scope="col">State / Region</th>
						<th data-testid="postal" key="postal" scope="col">Postal Code</th>
						<th data-testid="country" key="country" scope="col">Country</th>
						<th data-testid="note" key="note" scope="col">Note</th>
						<th data-testid="billing" key="billing" scope="col">Billing</th>
						<th data-testid="shipping" key="shipping" scope="col">Shipping</th>
					</tr>
				</thead>
				<tbody data-testid="addressTableBody">
					{!showModal && addressList && addressList.map((data: any, index) =>
						<tr key={"addresstr" + index}>
							<td data-testid={"address" + index} key={"address" + index}>{data.address1} {data.address2} {data.address3}</td>
							<td data-testid={"city" + index} key={"city" + index}>{data.city}</td>
							<td data-testid={"state" + index} key={"state" + index}>{data.region}</td>
							<td data-testid={"postal" + index} key={"postal" + index}>{data.postalCode}</td>
							<td data-testid={"country" + index} key={"country" + index}>{data.country}</td>
							<td data-testid={"note" + index} key={"note" + index}>{data.note}</td>
							<td data-testid={"billing" + index} key={"billing" + index}>
								<div className="">
									<input className="form-check-input" type="checkbox" id="billingId" name="billingId"
										checked={data.addressId == data.primaryBillingAddressId ? true : false} />
								</div>
							</td>
							<td data-testid={"shipping" + index} key={"shipping" + index}>
								<div className="">
									<input className="form-check-input" type="checkbox" id="shippingId" name="shippingId"
										checked={data.addressId == data.primaryShippingAddressId ? true : false} />
								</div>
							</td>
						</tr>
					)}
					{showModal &&
						<tr>
							<td colSpan={8} style={{ verticalAlign: "middle" }}>
								<DABInlineLoading />
							</td>
						</tr>
					}
					{!showModal && addressList.length <= 0 &&
						<tr>
							<td colSpan={8} style={{ verticalAlign: "middle" }}>
								No Data Found
							</td>
						</tr>
					}
				</tbody>
			</table>

			<Row className="ad-row">
				<Col className="verCenter" lg="6">
					<h5>
						<span data-testid="addressText">Shopify Addresses</span>
					</h5>
				</Col>
				{showSearch && <>
					<Col lg="6" style={{ float: "right" }}>
						<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
							onChange={(event) => { handleShopifyInputChange(event) }}
							value={searchShopifyText} onClick={(event) => { handleShopifyAddressFilter() }}
						/>
					</Col>
				</>
				}
			</Row>

			<table className="table table-bordered text-center" data-testid="addressTable">
				<thead>
					<tr>
						<th data-testid="note" key="name" scope="col">Name</th>
						<th data-testid="address" key="address" scope="col">Address</th>
						<th data-testid="city" key="city" scope="col">City</th>
						<th data-testid="state" key="state" scope="col">State / Region</th>
						<th data-testid="postal" key="postal" scope="col">Postal Code</th>
						<th data-testid="country" key="country" scope="col">Country</th>
					</tr>
				</thead>
				<tbody data-testid="addressTableBody">
					{!showModal && shopifyAddressList && shopifyAddressList.map((data: any, index) =>
						<tr key={"addresstr" + index}>
							<td data-testid={"note" + index} key={"note" + index}>{data.name}</td>
							<td data-testid={"address" + index} key={"address" + index}>{data.address1} {data.address2} </td>
							<td data-testid={"city" + index} key={"city" + index}>{data.city}</td>
							<td data-testid={"state" + index} key={"state" + index}>{data.province}</td>
							<td data-testid={"postal" + index} key={"postal" + index}>{data.zip}</td>
							<td data-testid={"country" + index} key={"country" + index}>{data.country}</td>
						</tr>
					)}
					{showModal &&
						<tr>
							<td colSpan={8} style={{ verticalAlign: "middle" }}>
								<DABInlineLoading />
							</td>
						</tr>
					}
					{!showModal && shopifyAddressList.length <= 0 &&
						<tr>
							<td colSpan={8} style={{ verticalAlign: "middle" }}>
								No addresses found for this user.
							</td>
						</tr>
					}
				</tbody>
			</table>

			<Modal isOpen={isAddDialogOpen} backdrop="static" centered data-testid="addressModal">
				<ModalHeader className="modal-header" >
					Add New Address</ModalHeader>
				<form name="createAddressform" onSubmit={handleAddSubmit}>
					<ModalBody className="modal-body">
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="createAddress1Text" htmlFor="report" className={["col-sm-5 col-form-label"].join(" ")}>Address 1</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createAddress1Value">
								<DABTextBox className={["form-control"].join(" ")} id="address1" isRequired={true}
									value={userAddressInputs.address1} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="createAddress2Text" htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")}>Address 2</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createAddress2Value">
								<DABTextBox className={["form-control"].join(" ")} id="address2"
									value={userAddressInputs.address2} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="createAddress3Text" htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")}>Address 3</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createAddress3Value">
								<DABTextBox className={["form-control"].join(" ")} id="address3"
									value={userAddressInputs.address3} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label data-testid="createCityText" htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")}>City</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createCityValue">
								<DABTextBox className={["form-control"].join(" ")} id="city" isRequired={true}
									value={userAddressInputs.city} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")} data-testid="createStateText">State / Region</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createStateValue">
								<DABTextBox className={["form-control"].join(" ")} id="region" isRequired={true}
									value={userAddressInputs.region} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")} data-testid="createPostalText">Postal Code</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createPostalValue">
								<DABTextBox className={["form-control"].join(" ")} id="postalCode" isRequired={true}
									value={userAddressInputs.postalCode} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")} data-testid="createCountryText">Country</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createCountryValue">
								<DABTextBox className={["form-control"].join(" ")} id="country" isRequired={true}
									value={userAddressInputs.country} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-5 col-form-label"].join(" ")} data-testid="createNoteText">Note</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createNoteValue">								
								<Input type="textarea" className={["form-control"].join(" ")} id="note" name="note"
									value={userAddressInputs.note} onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-5 col-form-label mr-4"].join(" ")} data-testid="createBillingText">Billing</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createBillingValue">
								<Input className={["form-control form-check-input"].join(" ")} type="checkbox" id="isPrimaryAddress"
									checked={userAddressInputs.isPrimaryAddress} name="isPrimaryAddress"
									onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-5 col-form-label mr-4"].join(" ")} data-testid="createShippingText">Shipping</label>
							<div className={["col-sm-6"].join(" ")} data-testid="createShippingValue">
								<Input className={["form-control form-check-input"].join(" ")} type="checkbox" id="isShippingAddress"
									checked={userAddressInputs.isShippingAddress} name="isShippingAddress"
									onChange={(event) => { handleAddInputChange(event) }} isHover={false} />
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="secondary" data-bs-dismiss="modal" onClick={handleCloseClick} data-testid="cancelAddressButton">Cancel</Button>
						<Button type="submit" color="primary" data-testid="saveAddressButton">Save</Button>
					</ModalFooter>
				</form>
			</Modal>
		</div >
	);
};

const mapStateToProps = (state: any) => {
	const { userData } = state;
	return {
		userData
	};
};

export default connect(mapStateToProps)(UserAddress);